import { createSlice } from "@reduxjs/toolkit";
import socketFactory from '../../../../utils/socketFactory.js';

const initialState = {
    id: null,
    map_id: null,
    date: null,
    room_id: null,
    title: null,
    description: null,
    allow_mic: true,
    allow_camera: true,
    allow_screen_share: true,
    allow_audio: true,
    allow_reaction: true,
    allow_messages: true,
    invite_all_internal: null,
    ext_inscription: false,
    registration_link: null,
    access_type: null,
    email_confirmation_enabled: false,
    reminder_on_event_day: false,
    reminder_5_min_before: false,
    participants: null,
    conferenceParticipants: []
}

const createConferenceSlice = createSlice({
    name: 'createConference',
    initialState,
    reducers: {
        setInit: (state) => {
            state.id = initialState.id;
            state.map_id = initialState.map_id;
            state.date = initialState.date;
            state.room_id = initialState.room_id;
            state.title = initialState.title;
            state.description = initialState.description;
            state.allow_mic = initialState.allow_mic;
            state.allow_camera = initialState.allow_camera;
            state.allow_screen_share = initialState.allow_screen_share;
            state.allow_audio = initialState.allow_audio;
            state.allow_reaction = initialState.allow_reaction;
            state.allow_messages = initialState.allow_messages;
            state.invite_all_internal = initialState.invite_all_internal;
            state.ext_inscription = initialState.ext_inscription;
            state.registration_link = initialState.registration_link;
            state.access_type = initialState.access_type;
            state.email_confirmation_enabled = initialState.email_confirmation_enabled;
            state.reminder_on_event_day = initialState.reminder_on_event_day;
            state.reminder_5_min_before = initialState.reminder_5_min_before;
            state.participants = initialState.participants;
            state.conferenceParticipants = initialState.conferenceParticipants;
        },
        setTitle: (state, action) => {
            state.title = action.payload
        },
        setDescription: (state, action) => {
            state.description = action.payload
        },
        setDate: (state, action) => {
            state.date = action.payload
        },
        setRoomId: (state, action) => {
            state.room_id = action.payload
        },
        setAllowMic: (state, action) => {
            state.allow_mic = action.payload
        },
        setAllowCamera: (state, action) => {
            state.allow_camera = action.payload
        },
        setAllowScreenShare: (state, action) => {
            state.allow_screen_share = action.payload
        },
        setAllowAudio: (state, action) => {
            state.allow_audio = action.payload
        },
        setAllowReaction: (state, action) => {
            state.allow_reaction = action.payload
        },
        setAllowMessages: (state, action) => {
            state.allow_messages = action.payload
        },
        setInviteAllInternal: (state, action) => {
            state.invite_all_internal = action.payload
        },
        setExternaInscreption: (state, action) => {
            state.ext_inscription = action.payload
        },
        setRegistrationLink: (state, action) => {
            state.registration_link = action.payload
        },
        setParticipants: (state, action) => {
            state.participants = action.payload
        },
        setAccessType: (state, action) => {
            state.access_type = action.payload
        },
        setEmailConfirmationEnabled: (state, action) => {
            state.email_confirmation_enabled = action.payload
        },
        setReminderOnEventDay: (state, action) => {
            state.reminder_on_event_day = action.payload
        },
        setReminder5MinBefore: (state, action) => {
            state.reminder_5_min_before = action.payload
        },
        setMapId: (state, action) => {
            state.map_id = action.payload
        },
        setId: (state, action) => {
            state.id = action.payload
        },
        setConferenceParticipants: (state, action) => {
            state.conferenceParticipants = action.payload
        },
        loadReservation: (state, action) => {
            const r = action.payload; 
            state.id = r.id;
            state.title = r.title;
            state.description = r.description;
            state.date = r.date;
            state.allow_mic = r.allow_mic;
            state.allow_camera = r.allow_camera;
            state.allow_screen_share = r.allow_screen_share;
            state.allow_audio = r.allow_audio;
            state.allow_reaction = r.allow_reaction;
            state.allow_messages = r.allow_messages;
            state.ext_inscription = r.ext_inscription;
            state.registration_link = r.registration_link;
            state.participants = r.participants;
            state.access_type = r.access_type;
            state.email_confirmation_enabled = r.email_confirmation_enabled;
            state.reminder_on_event_day = r.reminder_on_event_day;
            state.reminder_5_min_before = r.reminder_5_min_before;
            state.invite_all_internal = false;
            if (r.room_tenant) {
                state.room_id = r.room_tenant.room;
                state.map_id = r.room_tenant.room.map_id;
            }
        },

    }
})


export const {
    setTitle,
    setDescription,
    setDate,
    setRoomId,
    setAllowMic,
    setAllowCamera,
    setAllowScreenShare,
    setAllowAudio,
    setAllowReaction,
    setAllowMessages,
    setInviteAllInternal,
    setExternaInscreption,
    setRegistrationLink,
    setParticipants,
    setAccessType,
    setEmailConfirmationEnabled,
    setReminderOnEventDay,
    setReminder5MinBefore,
    setMapId,
    setId,
    setConferenceParticipants,
    setInit,
    loadReservation
} = createConferenceSlice.actions

export const NEW_RESERVATION = socketFactory.emit('newReservation', 'socket/newReservation');
export const UPDATE_RESERVATION = socketFactory.emit('updateReservation', 'socket/updateReservation');
export const DELETE_RESERVATION = socketFactory.emit('deleteReservation', 'socket/deleteReservation');

export default createConferenceSlice.reducer